module.exports = __webpack_public_path__ + "assets/img/wallet1-bj.0dd4650e.png";